import server from "../Server";
import { RegisterPayload } from "../../../gateways";
import withErrorCheck from "../CheckError";

export const Register = async (params: RegisterPayload): Promise<{ created: boolean } | null> => {
  await server.auth.signOut();
  const { user } = withErrorCheck(
    await server.auth.signUp({
      email: params.email,
      password: params.password,
      options: {
        emailRedirectTo: process.env.EXPO_PUBLIC_CLIENT_URL,
      },
    })
  );
  if (!user) {
    throw new Error("User couldn't be created.");
  }

  const existingPlayers = withErrorCheck(await server.from("Players").select().eq("email", params.email));

  if (existingPlayers && existingPlayers.length > 0) {
    const player = existingPlayers[0];

    if (player.user_id) {
      // Already linked → not allowed
      throw new Error("User with this email already exists.");
    }

    withErrorCheck(await server.from("Players").update({ user_id: user.id, name: params.name }).eq("id", player.id));

    return { created: true };
  }
  const players = withErrorCheck(await server.from("Players").select().eq("user_id", user.id));

  if (!!players && !!players.length) {
    throw new Error("User with this email already exists.");
  }

  withErrorCheck(
    await server.from("Players").insert({ name: params.name, user_id: user.id, email: params.email }).select()
  );

  return { created: true };
};
